import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  clearAllImportedData,
  getUploadedData,
  importAlldata,
} from "./services";
import { SearchParamsType } from "./types";
import { useNavigate } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloseIcon from '@mui/icons-material/Close';
const pageTitle = "ICD uploaded data";
function UploadedData() {
  const navigate = useNavigate();
  const { showSnackbar } = usePopup();
  const [searchParams, setSearchParams] = useState<SearchParamsType>({
    pageNumber: 0,
    pageSize: 25,
    searchText: "",
    sortField: "",
    sortOrder: "",
    status: 2,
    filter: { searchText: "", status: 2 }
  });
  const { mutate: clearImport, isLoading: clearLoading } = useMutation(
    clearAllImportedData,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          navigate(-1);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    }
  );
  const { data: uploadedList, isLoading: uploadListLoading } = useQuery(
    ["fetchFileUploadedList", searchParams],
    async () => await getUploadedData(searchParams)
  );

  const { mutate: importAll, isLoading: importLoading } = useMutation(
    importAlldata,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          navigate(-1);
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 3000,
          });
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    }
  );

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    pageNumber: number
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearchParams((prev) => ({
      ...prev,
      page: 0,
      pageSize: parseInt(event.target.value, 10),
    }));
  };

  const handleImport = () => {
    importAll();
  };

  const handleClearImport = () => {
    clearImport();
  };

  return (
    <div className="p-3">
      <TableContainer component={Paper} className="border">
        <div className="p-2 flex justify-between items-center">
          <Typography variant="h6">{pageTitle}</Typography>
          <div className="flex gap-2 items-center justify-center">
            <Button
              disabled={importLoading}
              endIcon={importLoading ? <CircularProgress size={18} /> : <CloudDownloadIcon />}
              onClick={handleImport}
            >
              import
            </Button>
            <Button
              color="error"
              disabled={clearLoading}
              endIcon={clearLoading ? <CircularProgress size={18} color="error"/> : <CloseIcon/>}
              onClick={handleClearImport}
            >
              cancel
            </Button>
          </div>
        </div>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {headings.map((heading) => (
                <TableCell key={heading.key} className="font-bold">
                  {heading.label}
                </TableCell>
              ))}
              <TableCell className="font-bold">Status</TableCell>
            </TableRow>
          </TableHead>
          <CustomTableBody
            alert={"No data"}
            dataLoading={uploadListLoading}
            isData={Boolean(uploadedList?.response?.icdUploadData?.length)}
            totalSpan={{
              row: searchParams.pageSize,
              col: headings.length + 3,
            }}
          >
            {uploadedList?.response?.icdUploadData?.map((tableItem, index) => (
              <TableRow key={`${pageTitle}-${index}`}>
                {headings.map((heading) => (
                  <TableCell>
                    {tableItem[heading.key as keyof typeof tableItem]}
                  </TableCell>
                ))}
                <TableCell>
                  {tableItem.icdStatus == 1 ? (
                    <div className="text-green-600 text-center rounded-[10px] w-[70px] font-semibold">
                      Active
                    </div>
                  ) : (
                    <div className="text-red-600 text-center rounded-[10px] w-[70px] font-semibold">
                      Inactive
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </CustomTableBody>
        </Table>
        <div className="flex justify-end">
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component={"div"}
            count={uploadedList?.response?.totalRecords || 0}
            rowsPerPage={searchParams.pageSize}
            page={searchParams.pageNumber}
            sx={{ border: 0 }}
            slotProps={{
              select: {
                inputProps: {
                  "aria-label": "rows per page",
                },
                native: true,
              },
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // ActionsComponent={TablePaginationActions}
          />
        </div>
      </TableContainer>
    </div>
  );
}

export default UploadedData;
const headings = [
  {
    label: "Code",
    key: "icdCode",
  },
  {
    label: "Name",
    key: "icdName",
  },
  {
    label: "Version",
    key: "icdVersion",
  },
  {
    label: "Description",
    key: "icdDescription",
  },
];
